import * as React from 'react';
import { Route } from 'react-router-dom';
import { commandeSchema } from './commande';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Commande
 */
const CommandeRoutes = [
    // Route de liste (principale)
    <Route
        key="commandes-list"
        path="commandes"
        element={<Main key="commandes-main" pageConfig={commandeSchema} />}
    />,
];

export default CommandeRoutes;
